import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import * as lodash from 'lodash';
import { SettingsMasterContext } from 'widgets/settings-master/model/context/type';
import Zont_X_line from './x-line.svg';
import Zont_R_line_1 from './r-line.svg';
const typeModelBoilerZota = {
    //x-line svg 1
    x_line: ['zota-solid-x', 'zota-mkx', 'zota-lux-x'],
    //r-line 223e svg 2
    r_line_1: ['zota-prom-emr', 'zota-mks', 'zota-solid', 'zota-mks-plus'],
    //r-line 222sfa 06/2022- 01/11/2023
    //r_line_222sfa: ['zota-twist', 'zota-pellet-s', 'zota-stahanov', 'zota-maxima', 'zota-robot'],
    //i-line 223sfa r-line 230 e
    r_line_2: [
        'zota-twist',
        'zota-twist-plus',
        'zota-pellet-s',
        'zota-pellet-black',
        'zota-stahanov',
        'zota-maxima',
        'zota-robot',
    ],
    other: ['zota-mkr', 'zota-prom-ssr'],
};
export function ConnectWiresHint() {
    const { dataSelectSettings } = useContext(SettingsMasterContext);
    if (dataSelectSettings?.boiler_model?.value == null) {
        return null;
    }
    else {
        const typForSVG = lodash.findKey(typeModelBoilerZota, function (o) {
            return lodash.includes(o, dataSelectSettings?.boiler_model?.value);
        });
        return (_jsxs(Box, { display: "flex", flexDirection: "column", width: "100%", justifyContent: "center", children: [typForSVG === 'x_line' && _jsx(Zont_X_line, { width: "100%", height: "100%" }), typForSVG === 'r_line_1' && (_jsx(Zont_R_line_1, { width: "100%", height: "100%" })), _jsx(Box, { mt: 1, children: _jsx(Typography, { variant: "subtitle1", color: "error", children: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u043E\u0432 \u043D\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u043B\u0435\u0440\u0435 \u0438 \u0432 ZONT \u043F\u043E \u0441\u0445\u0435\u043C\u0435." }) })] }));
    }
}
